const Grid = () => (
  <>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M4.5 7A2.5 2.5 0 0 1 7 4.5h10A2.5 2.5 0 0 1 19.5 7v10a2.5 2.5 0 0 1-2.5 2.5H7A2.5 2.5 0 0 1 4.5 17zM7 5.5A1.5 1.5 0 0 0 5.5 7v4.5h6v-6zm5.5 0v6h6V7A1.5 1.5 0 0 0 17 5.5zm6 7h-6v6H17a1.5 1.5 0 0 0 1.5-1.5zm-7 6v-6h-6V17A1.5 1.5 0 0 0 7 18.5z"
      clipRule="evenodd"
    />
  </>
)
export default Grid
